
// Dropdown and mega menu

const ddButtons = document.getElementsByClassName("mob-parent-button");

// Loop through each button
for (const ddButton of ddButtons) {
  // Add a click event listener to the button
  ddButton.addEventListener("click", function (event) {
    // Prevent the default behavior of the button click
    event.preventDefault();
    // Find the next sibling element and add the "active" class to it
    const nextElement = ddButton.nextElementSibling;
    if (nextElement) {
      nextElement.classList.add("active");
      document.getElementById("mobNavDrawer").scrollTo({ top: 0, behavior: "instant" });
      setTimeout(() => {
        hideOtherPanels();
      }, 250);
      //updateSlHideVisibility();
    }
  });
} 

function hideOtherPanels() {
  const mobileDrawer = document.querySelector("nav[data-mobile-nav]");

  const otherPanels = mobileDrawer.querySelectorAll(".mob-secondary-level-ul:not(.active)");
  const activePanel = mobileDrawer.querySelectorAll(".mob-secondary-level-ul.active");

  otherPanels.forEach(panel => panel.parentElement.classList.add("hp:hidden"));
  activePanel.parentElement.classList.remove("hp:hidden");

  const mobileExtraMenu = mobileDrawer.querySelector("ul[data-extra-mobile-menu]");
  mobileExtraMenu.classList.add("hp:hidden");
}

function showAllPanels() {
  const mobileDrawer = document.querySelector("nav[data-mobile-nav]");

  // Tüm gizlenen panelleri tekrar göster
  const allPanels = mobileDrawer.querySelectorAll(".mob-secondary-level-ul");
  allPanels.forEach(panel => panel.parentElement.classList.remove("hp:hidden"));

  // Extra mobile menu'yu tekrar göster
  const mobileExtraMenu = mobileDrawer.querySelector("ul[data-extra-mobile-menu]");
  mobileExtraMenu.classList.remove("hp:hidden");
}

const ddPanels = document.querySelectorAll(".mob-secondary-level-ul, .mob-third-level-ul");

// Function to update the visibility of sl-hide divs
function updateSlHideVisibility() {
  const isActivePanel = Array.from(ddPanels).some(panel => panel.classList.contains("active"));
  const slHideDivs = document.getElementsByClassName("sl-hide");

  for (const slHideDiv of slHideDivs) {
    if (isActivePanel) {
      slHideDiv.classList.add("sl-hide-oi");
    } else {
      slHideDiv.classList.remove("sl-hide-oi");
    }
  }
}

// Loop through each panel
for (const ddPanel of ddPanels) {
  // Find the "nav-secondary-fo-back-button" within the current panel
  const backButton = ddPanel.querySelector(".nav-secondary-fo-back-button");

  // Add a click event listener to the back button
  backButton.addEventListener("click", function () {
    // Remove the "active" class from the parent panel
    ddPanel.classList.toggle("active");
    
    // Geri dönüş düğmesine tıklandığında tüm panelleri tekrar göster
    showAllPanels();
    
    updateSlHideVisibility();
  });

  // Create a MutationObserver for each panel
  const panelObserver = new MutationObserver(() => {
    updateSlHideVisibility();
  });

  // Define what to observe within the panel for specific changes
  const observerConfig = { subtree: true, childList: true, attributes: true, characterData: true };

  // Start observing the panel for changes
  panelObserver.observe(ddPanel, observerConfig);
}


// Accordion menu system

document.addEventListener("DOMContentLoaded", function () {
  var drawerAccordionButtons = document.querySelectorAll(".mob-parent-accordion-button");
  drawerAccordionButtons.forEach(function (drawerAccordionButton) {
    drawerAccordionButton.addEventListener("click", function () {
      var panel = drawerAccordionButton.nextElementSibling;

      // Toggle the "open" class for the accordion heading
      if (drawerAccordionButton.classList.contains("active")) {
        drawerAccordionButton.classList.remove("active");
        drawerAccordionButton.setAttribute('aria-expanded', 'false');
        panel.style.height = null;
        setTimeout(function () {
          panel.classList.remove("panel-open");
          panel.setAttribute('aria-hidden', 'true');
        }, 600);
      } else {
        drawerAccordionButton.classList.add("active");
        drawerAccordionButton.setAttribute('aria-expanded', 'true');
        panel.style.height = panel.scrollHeight + "px";
        panel.setAttribute('aria-hidden', 'false');
        panel.classList.add("panel-open");
      }
    });
  });
});


// Dropdown menu interaction
if (!document.querySelector('.nav-desktop-dd-btn-clickable')) {
  const navDesktopButtons = document.querySelectorAll('.nav-desktop-dd-btn');
  const headerMegaFwLists = document.querySelectorAll('.header-nav-desktop-dd-panel, .hp-dropdown-desktop');
  const gcHeader = document.querySelector('.header-bar-inner');
    
  function applyBackgroundColor() {
    gcHeader.classList.add('hovered');
  }
  
  function removeBackgroundColor() {
    gcHeader.classList.remove('hovered');
  }
  
  navDesktopButtons.forEach((navDesktopButton) => {
    navDesktopButton.addEventListener('mouseover', applyBackgroundColor);
    navDesktopButton.addEventListener('mouseout', removeBackgroundColor);
  });
  
  headerMegaFwLists.forEach((headerMegaFwList) => {
    headerMegaFwList.addEventListener('mouseover', applyBackgroundColor);
    headerMegaFwList.addEventListener('mouseout', removeBackgroundColor);
  });
}

// Scrolling transition for transparent header option

const headerDiv = document.getElementById('SiteHeader');
const announcmentBar = document.getElementById('HdrAnnouncementBar');

const filterContainer = document.querySelector('.facets-container');
let filterOffsetTop = filterContainer
  ? filterContainer.getBoundingClientRect().top + window.pageYOffset
  : null;

const activeFacets = document.querySelector('.facets-pill');
const activeFacetsMobil = document.querySelector('.active-facets-mobile');

const filterPlaceholder = document.querySelector('.filter-placeholder');
const headerLogo = document.querySelector('.header-desktop-logo .header--logo');
const headerLogoImage = document.querySelector('.header-desktop-logo .header--logo .header--logo-std img');
window.addEventListener('load', () => {
let lastScroll = window.pageYOffset || 0;

let height;

function recalcHeight() {
  const isDesktop = window.innerWidth > 768;
  const rawH      = filterContainer.offsetHeight;
  const extra     = isDesktop ? 40 : 20;
  height = `${rawH + extra}px`;
  if (filterContainer.style.position === 'fixed') {
    filterPlaceholder.style.height = height;
  }else
  {
    filterPlaceholder.style.height = '';
  }
}

function isPLP() {
  return window.location.pathname.includes('/collections/');
}
if (isPLP()) {
  let lastSearch = window.location.search;
  setInterval(() => {
    const currentSearch = window.location.search;
    if (currentSearch !== lastSearch) {
      lastSearch = currentSearch;
      setTimeout(recalcHeight, 1600);
    }
  }, 200);
}

if (isPLP()) {
recalcHeight();
window.addEventListener('popstate', recalcHeight);
}

window.addEventListener('resize', () => {
  if (isPLP()) {
    setTimeout(recalcHeight, 200);
  }
});

  window.addEventListener('resize', () => {
    const path_l = window.location.pathname;
    const isHome_l = path_l === '/';
    const isDesktop_l = window.innerWidth > 900;
  if (isHome_l) {
    if(!isDesktop_l){
            headerDiv.style.transform = ''
        announcmentBar.style.transform = '';
                  headerDiv.style.opacity = '';
      announcmentBar.style.opacity = '';
    }
  }
});

const hdrTransition = 'transform .25s cubic-bezier(.104,.204,.492,1),opacity .25s ease';
headerDiv.style.transition = hdrTransition;
announcmentBar.style.transition = hdrTransition;
announcmentBar.style.willChange = 'transform';
window.addEventListener('scroll', function () {
  const currentScroll = window.pageYOffset || 0;
  const path = window.location.pathname;
  const isPLP = window.location.pathname.includes('/collections/');
  const isHome = path === '/';
  const isDesktop = window.innerWidth > 768;

  if(isHome){
        headerDiv.style.transform = ''
        announcmentBar.style.transform = '';
                  headerDiv.style.opacity = '';
      announcmentBar.style.opacity = '';
    if(isDesktop)
    {
      
    if (currentScroll > lastScroll) {
      if(isDesktop){
        headerDiv.style.transform = 'translateY(-100%)';
        announcmentBar.style.transform = 'translateY(-100%)';
              headerDiv.style.opacity = '0';
      announcmentBar.style.opacity = '0';
      }
      headerDiv.classList.remove('hdr-trans-hp');
  
      if(isDesktop)
        {
          headerLogo.style.width = '190px';
          headerLogo.style.height = '90px'
  
          headerLogoImage.style.width = '10px';
          headerLogoImage.style.height = '90px';
        }
  
      announcmentBar.style.display = 'none';
    } else if (currentScroll < lastScroll) {

      if(isDesktop)
      {
        headerDiv.style.transform = 'translateY(0)'
        announcmentBar.style.transform = 'translateY(0)';
              headerDiv.style.opacity = '1';
      announcmentBar.style.opacity = currentScroll > 0 ? '0' : '1';
      headerDiv.style.top = '0';
      }else
      {
        headerDiv.style.display = 'block';
      }
  
      if (currentScroll > 0) {
        headerDiv.classList.remove('hdr-trans-hp');
          if(isDesktop)
            {
              headerLogo.style.width = '190';
              headerLogo.style.height = '90px';
  
              headerLogoImage.style.width = '190px';
              headerLogoImage.style.height = '90px';
            }
      } else {
        if(isDesktop)
          {
            headerLogo.style.width = '';
            headerLogo.style.height = '';
  
            headerLogoImage.style.width = '';
            headerLogoImage.style.height = '';
          }
          announcmentBar.style.display = 'flex';
        headerDiv.classList.add('hdr-trans-hp');
      }
    }
  
    lastScroll = currentScroll <= 0 ? 0 : currentScroll;
    return;
    }
    else{
      if (currentScroll > lastScroll) {
      headerDiv.classList.remove('hdr-trans-hp');
        headerDiv.style.display = 'none';
        announcmentBar.style.display = 'none';
    } else if (currentScroll < lastScroll) {
        headerDiv.style.display = 'block';
      if (currentScroll > 0) {
        headerDiv.classList.remove('hdr-trans-hp');
      } else {
          announcmentBar.style.display = 'flex';
        headerDiv.classList.add('hdr-trans-hp');
      }
    }
  
    lastScroll = currentScroll <= 0 ? 0 : currentScroll;
    return;
    }
  }

  if (isPLP) {
    if (filterContainer && filterOffsetTop !== null) {
      if (currentScroll >= filterOffsetTop) {

        filterPlaceholder.style.height = height;
        filterContainer.style.position       = 'fixed';
        filterContainer.style.top            = '0';
        filterContainer.style.left           = '0';
        filterContainer.style.right          = '0';
        filterContainer.style.padding        = isDesktop ? '10px 40px 10px 40px': '5px 20px 5px 20px' ;
        filterContainer.style.backgroundColor = '#fff';
        filterContainer.style.zIndex         = '999';
        activeFacets.style.display        = 'none';
        activeFacetsMobil.style.display        = 'none';
      } else {
        filterContainer.style.position       = '';
        filterContainer.style.top            = '';
        filterContainer.style.left           = '';
        filterContainer.style.right          = '';
        filterContainer.style.padding        = '';
        filterContainer.style.backgroundColor = '';
        filterContainer.style.zIndex         = '';
        activeFacets.style.display        = '';
        activeFacetsMobil.style.display        = '';
        filterPlaceholder.style.height = '';
      }
    }
    if (currentScroll > 0) {
      headerDiv.style.display = 'none';
      announcmentBar.style.display = 'none';
    } else {
      headerDiv.style.display = 'block';
      announcmentBar.style.display = 'flex';
    }
    lastScroll = currentScroll <= 0 ? 0 : currentScroll;
    return;
  }

  if (currentScroll > lastScroll) {
    headerDiv.classList.remove('hdr-trans-hp');

    if(isDesktop)
      {
        headerLogo.style.width = '190px';
        headerLogo.style.height = '90px'

        headerLogoImage.style.width = '190px';
        headerLogoImage.style.height = '90px';
      }

    announcmentBar.style.display = 'none';
  } else if (currentScroll < lastScroll) {
    headerDiv.style.display = 'block';

    if (currentScroll > 0) {
      headerDiv.classList.remove('hdr-trans-hp');
        if(isDesktop)
          {
            headerLogo.style.width = '190px';
            headerLogo.style.height = '90px';

            headerLogoImage.style.width = '190px';
            headerLogoImage.style.height = '90px';
          }
    } else {
      if(isDesktop)
        {
          headerLogo.style.width = '';
          headerLogo.style.height = '';

          headerLogoImage.style.width = '';
          headerLogoImage.style.height = '';
        }
        announcmentBar.style.display = 'flex';
      headerDiv.classList.add('hdr-trans-hp');
    }
  }

  lastScroll = currentScroll <= 0 ? 0 : currentScroll;
});
});
// Menu drawer opening and closing

var navdrawermobile = document.getElementById('mobNavDrawer');
var drawbg = document.getElementById('drawBg');
var navbtns = document.querySelectorAll('.hdr-menu-button');
var navclose = document.getElementById('mobNavDrawerClose');
var lastFocusedButton = null;

// Function to open the menu drawer and set focus to the close button
function openMenuDrawer(event) {
  lastFocusedButton = event.currentTarget;
  navdrawermobile.classList.toggle('open');
  drawbg.classList.toggle('open');
  if (navdrawermobile.classList.contains('open')) {
    setTimeout(() => {
      navclose.focus();
    }, 200);
  }
  document.body.style.overflow = 'hidden';
  event.preventDefault();
}

// Event listeners to each menu button
navbtns.forEach(navbtn => {
  navbtn.addEventListener('click', openMenuDrawer);
  navbtn.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      openMenuDrawer(event);
    }
  });
});

if (navclose) { 
  navclose.addEventListener('click', function() {
    navdrawermobile.classList.remove('open');
    drawbg.classList.remove('open');
    lastFocusedButton?.focus();
    document.body.style.overflow = 'auto';
  });
}

if (drawbg) { 
  drawbg.addEventListener('click', function() {
    navdrawermobile.classList.remove('open');
    drawbg.classList.remove('open');
    lastFocusedButton?.focus();
  });
}

// Desktop dropdowns for click option
var panelBg = document.querySelector('.dd-click-drawer-bg');
var lastClickedButton = null;

document.querySelectorAll('.nav-desktop-dd-btn-clickable').forEach(item => {
  item.addEventListener('click', (event) => {
    event.preventDefault();

    const panel = item.nextElementSibling;
    const isSameButton = lastClickedButton === item;
    const gcHeader = document.querySelector('.header-bar-inner');

    // Hide all other panels
    document.querySelectorAll('.header-nav-desktop-dd-panel').forEach(p => {
      if (p !== panel) {
        p.classList.remove("dd-visible");
      }
    });

    if (panel) {
      if (isSameButton) {
        // If clicking the same button, toggle the background visibility
        panel.classList.toggle("dd-visible");
        panelBg.classList.toggle("visible");
        gcHeader.classList.add('hovered');        
      } else {
        // If clicking a different button, ensure background stays visible
        panel.classList.add("dd-visible");
        panelBg.classList.add("visible");
        gcHeader.classList.add('hovered');
      }
    }

    // Update last clicked button
    lastClickedButton = isSameButton ? null : item;
  });
});

// Close all dropdowns when clicking anywhere outside
if (!document.querySelector('.nav-desktop-dd-btn-hover')) {
  document.addEventListener('click', (event) => {
    // Check if the clicked target is not inside a dropdown or clickable button
    if (
      !event.target.closest('.header-nav-desktop-dd-panel') &&
      !event.target.closest('.nav-desktop-dd-btn-clickable') &&
      !event.target.closest('.hdr-search-btn')
    ) {
      // Hide all dropdowns
      document.querySelectorAll('.header-nav-desktop-dd-panel').forEach(panel => {
        panel.classList.remove("dd-visible");
        panelBg.classList.remove("visible");
        document.querySelector('.header-bar-inner').classList.remove('hovered');
      });
    }
  });
}